module.exports = __webpack_public_path__ + "img/login-logo.3afd44db.png";